<div mat-dialog-title>
  <span>{{'subscriptions.modal.info.title' | translate}}</span>
  <button mat-dialog-close>
    <i class="fa fa-times"></i>
  </button>
</div>
@if (loadingState | async; as state) {
  <div class="subscription__ctn">
    <mat-dialog-content>
      @if (state === actionState.READY && subscription) {
        <p>
          {{'subscriptions.modal.info.name' | translate}} : {{subscription.name}}
        </p>
        <p>
          {{'subscriptions.form.label.state' | translate}} : {{ 'customerAccount.list.state.'+subscription.state.toLocaleLowerCase()| translate}}
        </p>
        <!-- TODO: pas de description ???  pas remonté par le back -->
        <!-- <p>
        {{'subscriptions.form.label.description' | translate}} : {{subscription.description}}
      </p> -->
      <div>
        {{'subscriptions.form.label.energies' | translate}} :
        @for (energyOpt of energyList; track energyOpt; let isFirst = $first) {
          <div class="d-inline-block">
            <input type="checkbox" class="form-control" [value]="energyOpt" [id]="energyOpt"
              [checked]="selectedEnergies.indexOf(energyOpt) !== -1"
              disabled>
            <label class="label-checkbox">
              {{'stations.energy.' + energyOpt | translate}}
            </label>
          </div>
        }
      </div>
      <p>
        {{'customerAccount.details.state.enabled' | translate: {date: (subscription.lastEnabledDate | date:'dd/MM/yy')} }}
      </p>
      <!-- TODO: ce n'est pas remonté par le back non plus! -->
      <!-- <p>
      {{'subscriptions.form.label.startValidity' | translate}} :
      {{ subscription.validityStart }}
    </p>
    <p>
      {{'subscriptions.form.label.endValidity' | translate}} :
      {{ subscription.validityEnd }}
    </p> -->
    <!-- <ng-container *ngIf="data.type === USER_SUBSCRIPTION; else vehicleInfo">
    <p>
      {{'subscriptions.modal.info.user_login' | translate}} : {{subscription.userLogin}}
    </p>
    <p>
      {{'subscriptions.modal.info.user_name' | translate}} : {{subscription.userDisplayName}}
    </p>
  </ng-container>
  <ng-template #vehicleInfo>
    <p>
      {{'subscriptions.modal.info.vehicle' | translate}} : {{subscription.vehicleDisplayName}}
    </p>
  </ng-template> -->
}
@if (state === actionState.FAILED) {
  <div class="app-display-errors-message" [error]="error"></div>
}
@if (state === actionState.LOADING) {
  <span class="ui-loading" [model]="{isLoading: true}"></span>
}
</mat-dialog-content>
</div>
}